import React from 'react'
import './entity-display.scss'
import classnames from 'classnames'

const EntityTitle: React.FC<any> = (_) => <span className={classnames('entity-title', _.className)}>{_.children}</span>

interface IEntityDisplay {
    className?: string
    top?: {
        left?: JSX.Element
        right?: JSX.Element
    }
    mid?: {
        left?: JSX.Element
        right?: JSX.Element
    }
    bottom?: {
        left?: JSX.Element
        right?: JSX.Element
    }
}

const EntityDisplay: React.FC<IEntityDisplay> = (props) => {
    const { className, top, mid, bottom } = props

    return (
        <div className={classnames('entity-display', className)}>
            {(top?.left || top?.right) && (
                <div className={classnames('display-section-top')}>
                    {top.left && <div className={classnames('display-section-left')}>{top.left}</div>}
                    {top.right && <div className={classnames('display-section-right')}>{top.right}</div>}
                </div>
            )}
            {(mid?.left || mid?.right) && (
                <div className={classnames('display-section-mid')}>
                    {mid.left && <div className={classnames('display-section-left')}>{mid.left}</div>}
                    {mid.right && <div className={classnames('display-section-right')}>{mid.right}</div>}
                </div>
            )}
            {(bottom?.left || bottom?.right) && (
                <div className={classnames('display-section-bottom')}>
                    {bottom.left && <div className={classnames('display-section-left')}>{bottom.left}</div>}
                    {bottom.right && <div className={classnames('display-section-right')}>{bottom.right}</div>}
                </div>
            )}
        </div>
    )
}

export { EntityDisplay as default, EntityTitle }
